import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {
      userAccount: localStorage.getItem('fullUserInfo') ? JSON.parse(localStorage.getItem('fullUserInfo')).userAccount : '',
      userName: localStorage.getItem('fullUserInfo') ? JSON.parse(localStorage.getItem('fullUserInfo')).displayName : ''
    },
    currentUserRole: null
  },
  mutations: {
    setUserInfo (state, userInfo) {
      Object.keys(state.userInfo).forEach(key => { if (key in userInfo) state.userInfo[key] = userInfo[key] })
    },
    resetUserInfo (state) {
      state.userInfo = {
        userAccount: '',
        userName: ''
      }
    },
    setCurrentUserRole (state, finder) {
      if (JSON.parse(localStorage.getItem('fullUserInfo')).authenticationRoles.length !== 0) {
        // 若finder傳值進來，代表使用者有選取其他角色進行登入
        if (finder) {
          if (finder.roleMasterId) {
            state.currentUserRole = JSON.parse(localStorage.getItem('fullUserInfo')).authenticationRoles.find(element => element.roleMasterId === finder.roleMasterId)
          } else if (finder.roleName) {
            state.currentUserRole = JSON.parse(localStorage.getItem('fullUserInfo')).authenticationRoles.find(element => element.roleName.contains(finder.roleName))
          }
          // 否則，預設為第一個角色
        } else {
          state.currentUserRole = JSON.parse(localStorage.getItem('fullUserInfo')).authenticationRoles[0]
        }
      }
    },
    resetCurrentUserRole (state) {
      state.currentUserRole = null
    },
    initUserInfo (state) {
      state.userInfo.userAccount = JSON.parse(localStorage.getItem('fullUserInfo')).userAccount
      state.userInfo.userName = JSON.parse(localStorage.getItem('fullUserInfo')).displayName
    },
    logout (state) {
      state.userInfo = {
        userAccount: '',
        userName: ''
      }
      localStorage.removeItem('fullUserInfo')
      localStorage.removeItem('token')
    }
  },
  actions: {

  },
  getters: {
    getUserInfo: state => state.userInfo,
    getUserAccount: state => state.userInfo.userAccount,
    isLogin: state => state.userInfo.userAccount !== '' && state.userInfo.userName !== '' && localStorage.getItem('fullUserInfo') !== null && localStorage.getItem('token') !== null,
    // 取得目前角色名稱
    getCurrentUserRoleName: state => state.currentUserRole.roleName,
    getCurrentUserRoleType: state => state.currentUserRole.authenticationApplications.find(element => element.applicationName === '環境變數').authenticationApplicationItem.find(element => element.aitemCode === 'ROLE_TYPE').aitemValue,
    getApplicationItemValue: state => param => state.currentUserRole.authenticationApplications.find(app => app.route === param.path).authenticationApplicationItem.find(item => item.aitemCode === param.itemCode).aitemValue
  }
})
